import React, {Component} from 'react'
import {findDOMNode} from 'react-dom'
import PropTypes from 'prop-types'
import gql from 'graphql-tag'
import {CardBody, Col, Row, Form, Input, FormGroup, Label, Button, ButtonGroup, FormFeedback} from 'reactstrap'
import {SAVE_COMPANY} from './graphql'
import {Mutation, ApolloConsumer} from 'react-apollo'
import ImageCrop from '../Support/ImageCrop'
import {API_BASE_URL} from '../../utils/apiConfig'
import _ from 'lodash'
import {getUserPermissions} from '../../utils/userPermissions'
import Comments from '../Comments/Comments'
import {UploadOrReplaceFiles} from '../../utils/uploadFiles'
// import {withGaTracker, withGaEvent} from '../Support/GoogleAnalytics'
import CreatableSelect from '../Wps/CreatableSelect'
import {CompanyRoles} from './roles'

const formAttrNames = ['name', 'city', 'post_code', 'street', 'street_no', 'street_no_flat',
  'nip', 'krs', 'regon', 'email', 'phone', 'fax', 'www']

function GetFormValues(formElements) {
  formAttrNames.forEach(attr_name => {
    const formEl = formElements[attr_name]
    this[attr_name] = formEl.value
  })
}

const propTypes = {
  onClose: PropTypes.func,
  afterSubmit: PropTypes.func,
  company: PropTypes.object
}

const defaultProps = {
  company: {}
}

class CompanyForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      formIsDisabled: getUserPermissions('core.companies.update') === 'false',
      validation_errors: {},
      newObjectSavedId: null,
      logoCropSaveFunc: null,
      roles: props.company.roles || []
    }
  }

  componentDidMount() {
    if (this.state.formIsDisabled) {
      // eslint-disable-next-line react/no-find-dom-node
      findDOMNode(this).querySelectorAll('#company-form input').forEach(a => a.setAttribute('disabled', 'true'))
    }

    // withGaTracker(window.location.pathname + '/company_form') // GA TRACKER
  }

  handleSubmit(e, submitFunction, apolloClient) {
    let variables = _.assign({}, new GetFormValues(e.target.elements))
    this.props.company.id && (variables.id = this.props.company.id)
    variables.roles = this.state.roles

    submitFunction({
      variables: {attributes: variables},
      refetchQueries: ({data: {createOrUpdateCompany}}) =>
        (!this.props.company.id && !createOrUpdateCompany.errors) ? ['GetCompanies'] : []
    }).then(({data: {createOrUpdateCompany}}) => {
      if (createOrUpdateCompany.errors) {
        this.setState({validation_errors: JSON.parse(createOrUpdateCompany.errors)})
      } else {
        // withGaEvent({category: 'Company', action: 'save'}) // GA EVENT
        const company_id = createOrUpdateCompany.company.id

        // ADD LOGO FILE
        this.setState({
          logoCropSaveFunc: (file) => UploadOrReplaceFiles(company_id, 'Company', [file], {}, 'Attachments::Logo')
            .then((data) => this.updateLogoInStore(company_id, data[0], apolloClient))
        }, () => this.props.afterSubmit())
      }
    })
  }

  updateLogoInStore(objectId, newLogo, apolloClient) {
    let LogoFragment = gql`
    fragment LogoParts on Company {
      logo {
        id
        url
        thumb_url
      }
    }`

    newLogo.__typename = 'Attachment'
    apolloClient.writeFragment({
      id: `Company:${objectId}`,
      fragment: LogoFragment,
      data: {
        logo: newLogo,
        __typename: 'Company'
      }
    })
  }

  render() {
    const {company} = this.props

    return (
      <CardBody>
        <ApolloConsumer>
          {client => (
            <Mutation mutation={SAVE_COMPANY}>
              {(createOrUpdateCompany) =>
                <Form id='company-form' className="FormClassLabel" onSubmit={(e) => {
                  e.preventDefault()
                  this.handleSubmit(e, createOrUpdateCompany, client)
                }}>
                  <Row>
                    <Col md="2" style={{minWidth: '320px', minHeight: '300px'}}>
                      <h6>Logo</h6>
                      {this.state.formIsDisabled ?
                        <img alt='logo' src={company.logo && company.logo.id && API_BASE_URL + company.logo.url}/> :
                        <ImageCrop imageUrl={company.logo && company.logo.id && API_BASE_URL + company.logo.url}
                          editorWidth={300}
                          editorHeight={200}
                          saveImageFunction={this.state.logoCropSaveFunc}
                        />}
                    </Col>

                    <Col>
                      <Row md="auto">
                        <Col xs="12" sm="4">
                          <FormGroup>
                            <Label>Name</Label>
                            <Input
                              name="name"
                              type="text"
                              invalid={!!this.state.validation_errors.name}
                              defaultValue={company.name}
                              required
                            />
                            <FormFeedback>{this.state.validation_errors.name}</FormFeedback>
                          </FormGroup>
                        </Col>
                        <Col xs="12" sm="4">
                          <FormGroup>
                            <Label>City</Label>
                            <Input
                              name="city"
                              type="text"
                              defaultValue={company.city}
                            />
                          </FormGroup>
                        </Col>
                        <Col xs="12" sm="4">
                          <FormGroup>
                            <Label>Post code</Label>
                            <Input name="post_code"
                              type="text"
                              defaultValue={company.post_code}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs="12" sm="4">
                          <FormGroup>
                            <Label>Street</Label>
                            <Input name="street"
                              type="text"
                              defaultValue={company.street}
                            />
                          </FormGroup>
                        </Col>

                        <Col xs="12" sm="4">
                          <FormGroup>
                            <Label>Street no</Label>
                            <Input name="street_no"
                              type="text"
                              defaultValue={company.street_no}
                            />
                          </FormGroup>
                        </Col>
                        <Col xs="12" sm="4">
                          <FormGroup>
                            <Label>Street no flat</Label>
                            <Input
                              name="street_no_flat"
                              type="text"
                              defaultValue={company.street_no_flat}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs="12" sm="4">
                          <FormGroup>
                            <Label>NIP</Label>
                            <Input
                              name="nip"
                              type="text"
                              defaultValue={company.nip}
                            />
                          </FormGroup>
                        </Col>
                        <Col xs="12" sm="4">
                          <FormGroup>
                            <Label>KRS</Label>
                            <Input name="krs"
                              type="text"
                              defaultValue={company.krs}
                            />
                          </FormGroup>
                        </Col>
                        <Col xs="12" sm="4">
                          <FormGroup>
                            <Label>REGON</Label>
                            <Input
                              name="regon"
                              type="text"
                              defaultValue={company.regon}
                            />
                          </FormGroup>
                        </Col>
                      </Row>

                      <Row>
                        <Col xs="12" sm="3">
                          <FormGroup>
                            <Label>Email</Label>
                            <Input
                              name="email"
                              type="email"
                              defaultValue={company.email}
                            />
                          </FormGroup>
                        </Col>
                        <Col xs="12" sm="3">
                          <FormGroup>
                            <Label>Phone</Label>
                            <Input
                              name="phone"
                              type="text"
                              defaultValue={company.phone}
                            />
                          </FormGroup>
                        </Col>
                        <Col xs="12" sm="3">
                          <FormGroup>
                            <Label>Fax</Label>
                            <Input
                              name="fax"
                              type="text"
                              defaultValue={company.fax}
                            />
                          </FormGroup>
                        </Col>
                        <Col xs="12" sm="3">
                          <FormGroup>
                            <Label>www</Label>
                            <Input
                              name="www"
                              type="text"
                              defaultValue={company.www}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs="12" sm="6">
                          <CreatableSelect
                            label="Roles"
                            disabled={this.state.formIsDisabled}
                            id="roles-company-form"
                            valueKey="slug"
                            options={CompanyRoles}
                            value={this.state.roles}
                            multi={true}
                            creatable={false}
                            valueChangeFunction={val => this.setState({roles: val.map(o => o.slug)})}
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <ButtonGroup className="float-right">
                    {this.props.afterSubmit && !this.state.formIsDisabled && <Button color="primary" type="submit">Save</Button>}
                    {this.props.onClose && <Button color="danger" type='button' onClick={(e) => {
                      e.preventDefault()
                      this.props.onClose()
                    }}>Cancel</Button>}
                  </ButtonGroup>
                  <br/><br/>
                  {getUserPermissions('core.comments.index') &&
                  <Comments commentableId={company.id || this.state.newObjectSavedId} commentableType='Company'/>}
                </Form>
              }
            </Mutation>
          )}
        </ApolloConsumer>
      </CardBody>
    )
  }
}

CompanyForm.propTypes = propTypes
CompanyForm.defaultProps = defaultProps

export default CompanyForm



// WEBPACK FOOTER //
// ./src/components/Companies/CompanyForm.js